import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-modal';
import useFunctionKeys from './hooks/useFunctionKeys';
import styled from 'styled-components';

import poweredBy_Light from './img/login/PoweredBy_Light.svg';
import poweredBy_Dark from './img/login/PoweredBy_Dark.svg';

import ifmsLogo from './img/iFMS_B_New.svg';

import cal_bg1 from './img/login/cal_bg1.jpg';
import cal_bg2 from './img/login/cal_bg2.jpg';
import cal_bg3 from './img/login/cal_bg3.jpg';
import cal_bg4 from './img/login/cal_bg4.jpg';
import cal_bg5 from './img/login/cal_bg5.jpg';
import cal_bg6 from './img/login/cal_bg6.jpg';
import cal_bg7 from './img/login/cal_bg7.jpg';
import cal_bg8 from './img/login/cal_bg8.jpg';
import cal_bg9 from './img/login/cal_bg9.jpg';
import cal_bg10 from './img/login/cal_bg10.jpg';
import cal_bg11 from './img/login/cal_bg11.jpg';
import cal_bg12 from './img/login/cal_bg12.jpg';
import cal_bg13 from './img/login/cal_bg13.jpg';
import cal_bg14 from './img/login/cal_bg14.jpg';

import PrimaryButton from './ui/PrimaryButton';
import QRCode from "react-qr-code";
import { User } from './ifmsTypes';
import { useVersion } from './VersionCheckProvider';

const LoginScreen = styled.div`
@keyframes loadBackground {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

width: 100vw;
height: 100vh;
margin: 0;
background: #0f1720;
font-family: Arial, Helvetica, sans-serif;
color: var(--text);
background-color: var(--frameTint); 

& {
  --bg-image: none;
  --bg-position: center;
  --accent: #2c7be5;
  --accent2: #57a5ff;
  --frameTint: rgba(236,242,250,.66);
  --text: #13263f;
  --muted: #5d7090;
  --borderSoft: rgba(255,255,255,.42);
  --shadow: 0 0 0 1px rgba(19,38,63,.07), 0 18px 50px rgba(0,0,0,.20);
  --radius-lg: 30px;
  --radius-md: 14px;
  --content-width: clamp(360px, 20.8vw, 520px); /* 1920px에서 399px */
}
&, & * { box-sizing: border-box; }
.login-page { isolation: isolate; min-height: 100vh; position: relative; overflow: hidden; display: flex; align-items: center; justify-content: flex-start; padding: 72px 32px 96px 8vw; }
.login-page::before { content: ''; position: absolute; z-index: -1; inset: 0; opacity: 0; background-image: var(--bg-image); background-size: cover; background-position: var(--bg-position); animation: loadBackground 0.5s ease-out forwards; }
.login-shell { position: relative; width: var(--content-width); min-height: 0; overflow: hidden; display: grid; grid-template-columns: 1fr; border: 1px solid var(--borderSoft); border-radius: var(--radius-lg); background: linear-gradient(135deg, var(--frameTint), color-mix(in srgb, var(--frameTint) 84%, white 16%)); box-shadow: var(--shadow); backdrop-filter: blur(22px) saturate(115%); -webkit-backdrop-filter: blur(22px) saturate(115%); }
.login-shell::after { content: ''; position: absolute; inset: 0; pointer-events: none; background: linear-gradient(120deg, rgba(255,255,255,.20), rgba(255,255,255,.04) 52%, rgba(255,255,255,.08)); }
.stack-panel { position: relative; z-index: 1; display: flex; flex-direction: column; align-items: stretch; min-width: 0; padding: clamp(40px,2.5vw,64px) clamp(32px,2.1vw,56px); text-align: center; }
.brand-reload-link, .product-reload-link { display: block; width: fit-content; max-width: 100%; margin: 0 auto; color: inherit; text-decoration: none; cursor: pointer; outline: none; }
.brand-reload-link:focus-visible, .product-reload-link:focus-visible { outline: 3px solid var(--accent); outline-offset: 5px; border-radius: 6px; }
.stack-brand { display: flex; justify-content: center; margin: 0; }
.product-logo { display: block; width: auto; height: clamp(20px,1.15vw,30px); max-width: 100%; object-fit: contain; object-position: center; }
.form-wrap { width: 100%; margin: clamp(30px,1.9vw,50px) 0 0; }
.form-title { margin: 0; font-size: clamp(20px,1.1vw,29px); font-weight: 800; letter-spacing: -.02em; line-height: 1.15; white-space: nowrap; }
.form-subtitle { margin: clamp(6px,.42vw,11px) 0 0; color: var(--muted); font-size: clamp(12px,.70vw,19px); line-height: 1.45; white-space: nowrap; }
.field { position: relative; margin-bottom: 12px; text-align: left; }
.form-wrap .field:first-of-type { margin-top: clamp(22px,1.46vw,38px); }
.field input { width: 100%; height: 44px; padding: 0 12px 0 40px; border: 1px solid rgba(15,17,19,.16); border-radius: 9px; outline: none; background: rgba(255,255,255,.85); color: var(--text); font: inherit; font-size: 14px !important; box-sizing: border-box; transition: border-color .15s ease, box-shadow .15s ease; }
.field[data-field="password"] input { padding-right: 40px; }
.field input::placeholder { color: color-mix(in srgb, var(--muted) 85%, white 15%); font-size: 14px !important; }
.field input:focus { border: 1.5px solid var(--accent); box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent) 20%, transparent); }
.field.has-error input, .field.has-error input:focus { border: 1.5px solid #C02426; box-shadow: 0 0 0 3px rgba(192,36,38,.20); }
.field-icon, .toggle-password { position: absolute; top: 22px; width: 18px; height: 18px; transform: translateY(-50%); color: var(--muted); }
.field-icon { left: 12px; pointer-events: none; }
.toggle-password { right: 12px; display: grid; place-items: center; padding: 0; border: 0; background: transparent; cursor: pointer; outline: none; }
.toggle-password svg { position: absolute; width: 100%; height: 100%; }
.toggle-password .icon-eye-slash, .toggle-password.is-visible .icon-eye { display: none; }
.toggle-password.is-visible .icon-eye-slash { display: block; }
.toggle-password:focus-visible { outline: 3px solid color-mix(in srgb, var(--accent) 40%, white); outline-offset: 3px; border-radius: 5px; }
.error-marker { display: inline-grid; width: 14px; height: 14px; flex: 0 0 14px; place-items: center; border-radius: 50%; background: #C02426; color: #fff; font-size: 9px; font-weight: 700; line-height: 14px; }
.login-alert { display: none; align-items: flex-start; gap: 8px; margin: 12px 0 0; padding: 9px 11px; border-radius: 9px; background: rgba(192,36,38,.10); color: #C02426; font-size: 11px; line-height: 1.32; }
.login-alert .error-marker { margin-top: 1px; }
.login-alert.is-visible { display: flex; }
.signin-button { position: relative; width: 100%; height: clamp(44px,2.85vw,76px); margin-top: clamp(12px,.63vw,16px); border: 0; border-radius: var(--radius-md); background: linear-gradient(135deg, var(--accent), var(--accent2)); color: #fff; font: inherit; font-size: clamp(13px,.82vw,22px); font-weight: 700; cursor: pointer; box-shadow: 0 11px 22px color-mix(in srgb, var(--accent) 35%, transparent); transition: transform .18s, filter .18s, box-shadow .18s; outline: none; }
.login-alert.is-visible + .signin-button { margin-top: 12px; }
.signin-button:hover:not(:disabled) { filter: brightness(1.04); transform: translateY(-1px); }
.signin-button:focus-visible { outline: 3px solid #fff; outline-offset: 3px; box-shadow: 0 0 0 6px var(--accent); }
.signin-button:disabled:not(.is-loading) { cursor: not-allowed; opacity: .5; box-shadow: none; }
.signin-button.is-loading { cursor: wait; opacity: .76; box-shadow: none; }
.button-loading { display: none; }
.signin-button.is-loading .button-label { visibility: hidden; }
.signin-button.is-loading .button-loading { position: absolute; inset: 0; display: grid; place-items: center; }
.button-label { display: inline-flex; align-items: center; justify-content: center; }
.arrow { display: block; width: 16px; height: 16px; flex: 0 0 16px; margin-left: 6px; }
.stack-customer { display: flex; flex-direction: column; align-items: center; margin: clamp(36px,2.3vw,60px) 0 0; }
.customer-logo { display: block; width: auto; height: auto; max-width: 280px !important; margin: 0 auto; object-fit: contain; object-position: center; }
.footer-left { position: absolute; z-index: 1; bottom: 24px; left: 40px; display: flex; align-items: center; }
.footer-left img { display: block; width: auto; height: 20px; filter: drop-shadow(0 1px 1.5px rgba(0,0,0,.55)) drop-shadow(0 0 10px rgba(0,0,0,.30)); }
.footer-on-light .footer-left img { filter: drop-shadow(0 0 6px rgba(255,255,255,.60)); }
.sr-only { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0,0,0,0); white-space: nowrap; border: 0; }
@media (max-width: 1280px) {
  .login-page { overflow: auto; }
}
@media (min-width: 861px) and (max-width: 1280px) {
  .login-page { padding: 48px 32px 96px 8vw; }
}
@media (max-width: 860px) {
  .login-page { justify-content: center; padding: 28px 20px 96px; }
  .login-shell { width: min(420px, calc(100vw - 32px)); }
}
@media (max-width: 520px) {
  .login-shell { border-radius: 22px; }
  .footer-left { left: 18px; bottom: 17px; }
}
`;

const THEME_CONFIGS = [
  { bg: cal_bg1, accent: '#2c7be5', accent2: '#57a5ff', frameTint: 'rgba(236,242,250,0.66)', text: '#13263f', muted: '#5d7090' },
  { bg: cal_bg2, accent: '#2b74d6', accent2: '#4ea1ff', frameTint: 'rgba(242,242,240,0.60)', text: '#14263d', muted: '#63738e' },
  { bg: cal_bg3, accent: '#2f7d32', accent2: '#6fbf73', frameTint: 'rgba(245,246,226,0.58)', text: '#1b2c25', muted: '#5f6f5e' },
  { bg: cal_bg4, footerLogo: 'light', accent: '#2c7be5', accent2: '#5bb1ff', frameTint: 'rgba(238,244,252,0.62)', text: '#13263f', muted: '#66758e' },
  { bg: cal_bg5, accent: '#198754', accent2: '#4dc98c', frameTint: 'rgba(240,242,223,0.57)', text: '#1c3028', muted: '#5e746a' },
  { bg: cal_bg6, accent: '#0b6aa2', accent2: '#2ca4db', frameTint: 'rgba(230,240,234,0.55)', text: '#10273a', muted: '#576f7e' },
  { bg: cal_bg7, accent: '#1c74e9', accent2: '#3eb2ff', frameTint: 'rgba(225,239,246,0.60)', text: '#13263f', muted: '#61748e' },
  { bg: cal_bg8, accent: '#2d6a37', accent2: '#5ca969', frameTint: 'rgba(233,235,230,0.57)', text: '#1b2c25', muted: '#677267' },
  { bg: cal_bg9, footerLogo: 'light', accent: '#d94e89', accent2: '#ef7daa', frameTint: 'rgba(248,234,240,0.63)', text: '#3a2030', muted: '#826778' },
  { bg: cal_bg10, accent: '#d15f1d', accent2: '#f29b4b', frameTint: 'rgba(245,234,219,0.60)', text: '#33231b', muted: '#7c6b61' },
  { bg: cal_bg11, accent: '#ef6c1b', accent2: '#ff9a3d', frameTint: 'rgba(245,233,223,0.58)', text: '#34231d', muted: '#7b6a5a' },
  { bg: cal_bg12, accent: '#2c7be5', accent2: '#58a9ff', frameTint: 'rgba(234,241,249,0.61)', text: '#13263f', muted: '#60748d' },
  { bg: cal_bg13, accent: '#435f2d', accent2: '#7f9c52', frameTint: 'rgba(237,238,229,0.59)', text: '#203021', muted: '#6a7167' },
  { bg: cal_bg14, accent: '#2b6cb0', accent2: '#63b3ed', frameTint: 'rgba(233,236,241,0.58)', text: '#17283d', muted: '#697688' }
];

const ModalContentStyle:React.CSSProperties = {
  top: '13%',
  left: '38%',
  right: 'auto',
  bottom: 'auto',
  zIndex: 10000,
  width: '700px',
};
const ModalContentStyle2:React.CSSProperties = {
  top: '35%',
  left: '38%',
  right: 'auto',
  bottom: 'auto',
  zIndex: 10000,
  width: '400px',
};
const ModalOverlayStyle:React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.55)',
  zIndex: 999998,
};

type Props = {
  onLogin: (username: string, password: string, rememberMe: boolean, urlPrefix:string) 
      => Promise<{ success: boolean; user: any; errorMessage: string | null; } | undefined>,
    fineOtherTabLogin: (username: string) => Promise<boolean>,
    //2fa
    suntekUser: User| undefined,
    suntekAdmin2FAActive:boolean,
    do2FAActive: (username:string, password:string, code: string) => Promise<string>,
    suntekAdminVerify:boolean,
    doSuntekAdminAuth: (username:string, password:string, code: string) => Promise<string>,
    on2FAActiveCancel: () => void,
    onSuntekAdminAuthCancel: () => void,
    deleteInvalidMemo: (username: string)  => Promise<boolean>,
    useOrchid: boolean,
    logoImg: string,
    logoName: string,
    updatePendingTask: () => Promise<boolean>,
};

const Login: React.FC<Props> = ({ onLogin, fineOtherTabLogin, 
  //2fa
  suntekUser,
  suntekAdmin2FAActive,
  do2FAActive,
  suntekAdminVerify,
  doSuntekAdminAuth,
  on2FAActiveCancel, onSuntekAdminAuthCancel,
  deleteInvalidMemo,
  useOrchid,
  logoImg,
  logoName,
  updatePendingTask,
}) => {
  useFunctionKeys({ onEnter });
  const enter = 13;

  const [themeIndex] = useState(() => {
    const storageKey = 'ifms-last-theme-index';
    let lastIndex = -1;
    try { lastIndex = Number.parseInt(sessionStorage.getItem(storageKey) || '-1', 10); } catch (_) {}
    let index = Math.floor(Math.random() * THEME_CONFIGS.length);
    if (THEME_CONFIGS.length > 1 && index === lastIndex) {
      index = (index + 1 + Math.floor(Math.random() * (THEME_CONFIGS.length - 1))) % THEME_CONFIGS.length;
    }
    try { sessionStorage.setItem(storageKey, String(index)); } catch (_) {}
    return index;
  });

  const currentTheme = THEME_CONFIGS[themeIndex] || THEME_CONFIGS[0];

  const [email, _setEmail] = useState<string>('');
  const [password, _setPassword] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [imageFailed, setImageFailed] = useState(false);

  const emailRef = useRef<string>('');
  const passwordRef = useRef<string>('');
  const rememberRef = useRef<boolean>(false);

  //<240808.dwshin. Suntek Admin ID Pattern Update - 2FA Add
  const [verifycode, _setVerifycode] = useState<string>('');
  const [veriftErrorMsg, setVeriftErrorMsg] = useState<string>('');
  const [authcode, _setAuthcode] = useState<string>('');
  const [authErrorMsg, setAuthErrorMsg] = useState<string>('');
  //240808.dwshin>
  const { checkForUpdates, setNeedsRefresh } = useVersion();

  function setEmail(v: string) {
    emailRef.current = v;
    _setEmail(v);
    setErrorMessage('');
  }

  function setPassword(v: string) {
    passwordRef.current = v;
    _setPassword(v);
    setErrorMessage('');
  }

  useEffect(() => {
    const focusElement = document.getElementById('email');
    if (focusElement) {
      focusElement.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function doLogin() {
    const host = window.location.host.toLowerCase();
    const preIndex = host.indexOf('-ofms.suntekscm.co') > -1 ? host.indexOf('-ofms.suntekscm.co') : host.indexOf('-ifms.suntekscm.co');

    const canLogin = preIndex > 0;
    if (!canLogin) {
      setErrorMessage('Invalid Site');
      return;
    }

    setIsLoading(true);
    if ((emailRef.current?.length??0) <= 0 || (passwordRef.current?.length??0) <= 0) {
      setErrorMessage('User ID or Password is empty.');
      setIsLoading(false);
      return;
    }
    
    const result = await fineOtherTabLogin(emailRef.current);
    if(!result){
      setErrorMessage('Already logged in.');
      setIsLoading(false);
      return;
    }
    let urlPrefix = window.location.host.substring(0, preIndex);

    const versionCheck = await checkForUpdates();
    if (!versionCheck) {
      setNeedsRefresh(true);
      setIsLoading(false);
      return; // 릴리즈된버전이랑 로드된 버전이랑 다르면 로그인 안하고 refresh 화면으로 넘어가게끔
    }

    const apiResult = await onLogin(emailRef.current, passwordRef.current, rememberRef.current, urlPrefix);
    if (apiResult && apiResult.success) {
      setErrorMessage('');
      // 현재 로그인한 유저가 생성했던 memo 중 id가 음수인 데이터를 제거
      await deleteInvalidMemo(apiResult.user.name);
      // 로그인 시 Pending된 데이터 중 Remind Date가 Today와 비교하여 7일 이전의 데이터는 자동으로 "Done" 으로 변경
      //생성된 모든 Task는 Create Date로부터 1년이 지나면 자동으로 Task가 Delete되도록 동작 (Pending/Done 전부 Delete)
      await updatePendingTask();
      setIsLoading(false);
      return;
    }

    if (apiResult) {
      let msg = null;
      if(typeof apiResult.user?.errors === 'string'){
        msg = apiResult.user?.errors;
      }

      setErrorMessage(msg ?? apiResult.user?.errors.message ?? apiResult.errorMessage ?? '');
    }
    setIsLoading(false);
  }

  function handleEmailChange(e: React.ChangeEvent<HTMLInputElement>) {
    setEmail(e.target.value);
  }

  function handlePasswordChange(e: React.ChangeEvent<HTMLInputElement>) {
    setPassword(e.target.value);
  }

  //<240808.dwshin. Suntek Admin ID Pattern Update - 2FA Add
  function handleVerifycodeChange(e: React.ChangeEvent<HTMLInputElement>) {
    _setVerifycode(e.target.value);
  }
  function handleAuthcodeChange(e: React.ChangeEvent<HTMLInputElement>) {
    _setAuthcode(e.target.value);
  }
  //240808.dwshin.>


  function onEnter(): boolean {
    const email = document.getElementById('email')
    if (email && email === document.activeElement) {

      const password = document.getElementById('password') as HTMLInputElement;
      if (password) {
        password.focus();
        password.select();
      }
    } else {
      doLogin();
    }

    return true;
  }

  async function on2FAActive() {
    setVeriftErrorMsg('');
    
    if (verifycode) {
      if(isNaN(parseInt(verifycode.replaceAll('-', '')))){
        setVeriftErrorMsg('Verification code is invalid.');
      }

      let errorMsg = await do2FAActive(emailRef.current, passwordRef.current, verifycode);
      if (errorMsg) {
        setVeriftErrorMsg(errorMsg);
      }
    }
  }
  
  async function onSuntekAdminAuth() {
    setAuthErrorMsg('');
    
    if (authcode) {
     if(isNaN(parseInt(authcode.replaceAll('-', '')))){
        setAuthErrorMsg('Verification code is invalid.');
      }

      let errorMsg = await doSuntekAdminAuth(emailRef.current, passwordRef.current, authcode);
      if (errorMsg) {
        setAuthErrorMsg(errorMsg);
      }
    }
  }

  const themeStyle = {
    '--bg-image': `url(${currentTheme.bg})`,
    '--accent': currentTheme.accent,
    '--accent2': currentTheme.accent2,
    '--frameTint': currentTheme.frameTint,
    '--text': currentTheme.text,
    '--muted': currentTheme.muted,
  } as React.CSSProperties;

  return (
    <LoginScreen style={themeStyle} className={`${currentTheme.footerLogo === 'light' ? 'footer-on-light' : ''}`}>
      <main className="login-page">
        <section className="login-shell" aria-label="iFMS login panel">
          <div className="stack-panel">
            <header className="stack-brand">
              <a className="product-reload-link" href="/login" aria-label="Reload iFMS login">
                <img className="product-logo" src={ifmsLogo} alt="iFMS" />
              </a>
            </header>
            <div className="form-wrap">
              <h2 className="form-title">Welcome Back</h2>
              <p className="form-subtitle">Sign in to access your workspace</p>
              <form onSubmit={(e) => { e.preventDefault(); doLogin(); }}>
                <div className="field">
                  <svg className="field-icon" viewBox="0 0 256 256" aria-hidden="true">
                    <circle cx="128" cy="96" r="52" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="18"/>
                    <path d="M31 216a104 104 0 0 1 194 0" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="18"/>
                  </svg>
                  <input 
                    id="email" 
                    name="email" 
                    type="text" 
                    placeholder="User ID" 
                    autoComplete="username" 
                    value={email}
                    onChange={handleEmailChange}
                  />
                </div>
                <div className="field">
                  <svg className="field-icon" viewBox="0 0 256 256" aria-hidden="true">
                    <rect x="40" y="88" width="176" height="128" rx="12" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="18"/>
                    <path d="M92 88V52a36 36 0 0 1 72 0V88" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="18"/>
                  </svg>
                  <input 
                    id="password" 
                    name="password" 
                    type={showPassword ? "text" : "password"} 
                    placeholder="Password" 
                    autoComplete="current-password"
                    value={password}
                    onChange={handlePasswordChange}
                  />
                  <button type="button" className="toggle-password" aria-label="Toggle password" onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? (
                      <svg viewBox="0 0 256 256" aria-hidden="true">
                        <path d="M208 208 48 48M104 104a40 40 0 0 0 48 48M92 60a116 116 0 0 1 36-4c72 0 108 72 108 72a202 202 0 0 1-42 51M68 68a202 202 0 0 0-48 60s36 72 108 72a116 116 0 0 0 36-4" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="18"/>
                      </svg>
                    ) : (
                      <svg viewBox="0 0 256 256" aria-hidden="true">
                        <circle cx="128" cy="128" r="40" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="18"/>
                        <path d="M20 128s36-72 108-72 108 72 108 72-36 72-108 72S20 128 20 128Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="18"/>
                      </svg>
                    )}
                  </button>
                </div>

                <div className={`login-alert ${errorMessage ? 'is-visible' : ''}`} role="alert" aria-live="polite" aria-hidden={!errorMessage}>
                  <span className="error-marker" aria-hidden="true">!</span>
                  <span>{errorMessage}</span>
                </div>

                <button className={`signin-button ${isLoading ? 'is-loading' : ''}`} type="submit" disabled={isLoading}>
                  <span className="button-label">
                    Sign In 
                    <svg className="arrow" width="20" height="20" viewBox="0 0 256 256" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20" aria-hidden="true">
                      <path d="M40 128h176M144 56l72 72-72 72"/>
                    </svg>
                  </span>
                  <span className="button-loading" aria-hidden="true">Signing in…</span>
                </button>
              </form>
            </div>
            
            {logoImg && logoImg.trim() !== '' && !imageFailed && (
            <footer className="stack-customer">
              <img 
                className="customer-logo" 
                src={`/logos/${logoImg}.webp`} 
                onError={() => setImageFailed(true)}
              />
            </footer>)}
          </div>
        </section>

        <div className="footer-left">
          <img 
            src={currentTheme.footerLogo === 'light' ? poweredBy_Light : poweredBy_Dark} 
            alt="Powered by Suntek" 
          />
        </div>
      </main>

      <Modal
        isOpen={suntekAdmin2FAActive}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        contentLabel=""
        style={{
          overlay: ModalOverlayStyle,
          content: ModalContentStyle
        }}
      >
        <p>Your login is protected with two-factor authentication, 
        please go through the following steps:</p>
        <ol className="list" style={{width:'628px'}}>
          <li>
            <p>
              <b>Download a two-factor authenticator app</b> like Microsoft Authenticator for&nbsp;
              <a target="_blank" rel="noreferrer" href="https://go.microsoft.com/fwlink/?Linkid=825071">Windows Phone</a>,&nbsp;
              <a target="_blank" rel="noreferrer" href="https://go.microsoft.com/fwlink/?Linkid=825072">Android</a> and&nbsp;
              <a target="_blank" rel="noreferrer" href="https://go.microsoft.com/fwlink/?Linkid=825073">iOS</a> or
              Google Authenticator for&nbsp;
              <a target="_blank" rel="noreferrer" href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&amp;hl=en">Android</a> and&nbsp;
              <a target="_blank" rel="noreferrer" href="https://itunes.apple.com/us/app/google-authenticator/id388497605?mt=8">iOS</a>.
            </p>
          </li>
          {suntekUser && suntekUser.authenticatorUri &&
            <li>
              <p><b>Scan the QR Code</b> or enter this key <kbd>{suntekUser.sharedKey}</kbd> into your two factor authenticator app. Spaces and casing do not matter.</p>
              <QRCode
                size={256}
                style={{ height: "auto", width: "120px" }}
                value={suntekUser.authenticatorUri}
                viewBox={`0 0 256 256`}
              />
            </li>
          }
          <li>
            <p>
              Once you have scanned the QR code or input the key above, your two factor authentication app will provide you
              with a unique code.<br />
              Enter 6 digit OTP code in the confirmation box below.
            </p>
            <div className="row">
              <div className="col-md-6">
                <label className="control-label">Verification Code</label>
                <input className="form-customize" type="text"
                  id="verifycode"
                  name="verifycode"
                  value={verifycode}
                  onChange={handleVerifycodeChange}
                  onKeyDown={(e) => {
                    if (e.keyCode === enter) {
                      on2FAActive();
                      e.preventDefault();
                      e.stopPropagation();
                    }
                  }}
                  autoComplete="off"
                  list="suntek-scm-login-verifycode"
                />
              </div>
            </div>
          </li>
        </ol>

        <div id="verify-button" style={{ margin: '0 0 0 40px', }}>
          <PrimaryButton className="loginbtn-auth" onClick={on2FAActive}>Verify</PrimaryButton>
          <PrimaryButton className="btn" onClick={() => {
            _setVerifycode('');
            on2FAActiveCancel();
            }} style={{margin: '0 0 0 8px'}} >
              Cancel</PrimaryButton>
        </div>
        <div id="veriftErrorMsg" style={{ textAlign: 'center', margin: '0 0 15px', }}>
          <label id="Error" style={{ color: '#ff3232', fontWeight: 'bold', margin: 0 }}>{veriftErrorMsg}</label>
        </div>
      </Modal>

      <Modal
        isOpen={suntekAdminVerify}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        contentLabel=""
        style={{
          overlay: ModalOverlayStyle,
          content: ModalContentStyle2
        }}
      >
        <p>Your login is protected with an authenticator app.<br /> Enter your authenticator code below.</p>
          <div className="row">
            <div className="col-md-6">
              <label className="control-label">Authenticator code</label>
              <input className="form-customize" type="text"
                id="authcode"
                name="authcode"
                value={authcode}
                onChange={handleAuthcodeChange}
                onKeyDown={(e) => {
                  if (e.keyCode === enter) {
                    onSuntekAdminAuth();
                    e.preventDefault();
                    e.stopPropagation();
                  }
                }}
                autoComplete="off"
                list="suntek-scm-login-verifycode"
              />
            </div>
          </div>

        <div id="auth-button" style={{ margin: '10px 0 3px 3px' }}>
          <PrimaryButton className="loginbtn-auth" onClick={onSuntekAdminAuth}>Login</PrimaryButton>
          <PrimaryButton className="btn" onClick={() => {
              _setAuthcode('');
              onSuntekAdminAuthCancel();
            }} style={{margin: '0 0 0 8px'}}>Cancel</PrimaryButton>
        </div>
        <div id="authErrorMsg" style={{ textAlign: 'center', margin: '0 0 15px', }}>
          <label id="Error" style={{ color: '#ff3232', fontWeight: 'bold', margin: 0 }}>{authErrorMsg}</label>
        </div>
      </Modal>

    </LoginScreen>
  );
};

Login.propTypes = {
  onLogin: PropTypes.func.isRequired,
};
export default Login;
